export const TicketStatus = Object.freeze({
  OPEN: 'Aberto',
  IN_PROGRESS: 'Em atendimento',
  CLOSED: 'Concluido',
});
